export const courtsConstants = {
  SET_STATE_COURTS_STATUS: "SET_STATE_COURTS_STATUS",

  GET_COURTS_STATUS: "GET_COURTS_STATUS",
  GET_COURTS_STATUS_PENDING: "GET_COURTS_STATUS_PENDING",
  GET_COURTS_STATUS_FULFILLED: "GET_COURTS_STATUS_FULFILLED",
  GET_COURTS_STATUS_FAILURE: "GET_COURTS_STATUS_FAILURE",

  SET_COURTS_STATUS: "SET_COURTS_STATUS",
  SET_COURTS_STATUS_PENDING: "SET_COURTS_STATUS_PENDING",
  SET_COURTS_STATUS_FULFILLED: "SET_COURTS_STATUS_FULFILLED",
  SET_COURTS_STATUS_FAILURE: "SET_COURTS_STATUS_FAILURE",

  GET_COURT_STATUS_LIST: "GET_COURT_STATUS_LIST",
  GET_COURT_STATUS_LIST_PENDING: "GET_COURT_STATUS_LIST_PENDING",
  GET_COURT_STATUS_LIST_FULFILLED: "GET_COURT_STATUS_LIST_FULFILLED",
  GET_COURT_STATUS_LIST_FAILURE: "GET_COURT_STATUS_LIST_FAILURE"
};
